// Batched, fire-and-forget UI activity log (page views, clicks, tab visibility).
// Never records typed input, mouse movement, or keystrokes. Failures are swallowed on purpose.
const FLUSH_MS = 30000
const MAX_BUFFER = 500
const CONTROL = 'a, button, [role="button"], input[type="submit"], input[type="button"], summary, [data-track], [wire\\:click]'

export function describeClick(target) {
    const control = target?.closest?.(CONTROL)
    if (!control) return null

    const attr = (name) => control.getAttribute(name)
    const tag = control.tagName.toLowerCase()
    const label = attr('data-track') || attr('aria-label') || attr('wire:click') || control.id
    if (label) return `${tag}:${label}`.slice(0, 120)
    // Link text can contain patient names, so links are identified by path only (no query/hash).
    if (tag === 'a') return `a:${(attr('href') || '').split(/[?#]/)[0]}`.slice(0, 120)

    return `${tag}:${(control.textContent || '').trim().replace(/\s+/g, ' ')}`.slice(0, 120)
}

export function startUiActivityTracking(win, doc) {
    const endpoint = doc.querySelector('meta[name="ui-activity-endpoint"]')?.content
    if (!endpoint || !win.navigator?.sendBeacon) return

    let buffer = []

    const push = (e, x = null) => {
        if (buffer.length >= MAX_BUFFER) return
        buffer.push({ e, x, u: win.location.href, t: Date.now() })
    }

    const flush = () => {
        if (!buffer.length) return
        const token = doc.querySelector('meta[name="csrf-token"]')?.content ?? ''
        const body = new FormData()
        body.append('_token', token)
        body.append('events', JSON.stringify(buffer))
        // sendBeacon returns false when the browser refuses to queue it: keep the buffer and retry next tick.
        if (win.navigator.sendBeacon(endpoint, body)) buffer = []
    }

    push('view')
    doc.addEventListener('click', (event) => {
        const x = describeClick(event.target)
        if (x) push('click', x)
    }, { capture: true, passive: true })
    doc.addEventListener('livewire:navigated', () => push('view'))
    doc.addEventListener('visibilitychange', () => {
        push(doc.visibilityState === 'hidden' ? 'hidden' : 'visible')
        if (doc.visibilityState === 'hidden') flush()
    })
    win.setInterval(() => { if (doc.visibilityState === 'visible') flush() }, FLUSH_MS)
}
